import { state } from '@/manager/convocation/store/state';
import { getters } from '@/manager/convocation/store/getters';
import { mutations } from '@/manager/convocation/store/mutations';
import { actions } from '@/manager/convocation/store/action';

export const convocation = {
    state,
    getters,
    actions,
    mutations,
};
